module.exports = __webpack_public_path__ + "img/good.47ea2d0e.svg";